import axios from 'axios';

// --- Environment Variables ---
// These variables should be set in your project's .env.local file.
// VITE_IPFS_JWT: Your Pinata API Key (JWT).
// VITE_IPFS_GATEWAY_URL: Your dedicated Pinata gateway URL.

const IPFS_JWT = import.meta.env.VITE_IPFS_JWT;
const IPFS_GATEWAY_URL = import.meta.env.VITE_IPFS_GATEWAY_URL || 'https://gateway.pinata.cloud';

/**
 * Uploads a file to IPFS using the Pinata API.
 * @param file The file to upload.
 * @returns The IPFS gateway URL for the uploaded file.
 * @throws Throws an error if the upload fails.
 */
export const uploadToIPFS = async (file: File | Blob): Promise<string> => {
  if (!IPFS_JWT) {
    throw new Error('VITE_IPFS_JWT is not set in the environment variables. Please add it to your .env.local file.');
  }

  const formData = new FormData();
  formData.append('file', file);

  try {
    const response = await axios.post('https://api.pinata.cloud/pinning/pinFileToIPFS', formData, {
      headers: {
        'Authorization': `Bearer ${IPFS_JWT}`,
      },
    });
    
    const ipfsHash = response.data.IpfsHash;
    // Use the user-defined gateway, or fallback to the public one.
    return `${IPFS_GATEWAY_URL}/ipfs/${ipfsHash}`;

  } catch (error) {
    console.error("Error uploading to IPFS:", error);
    if (axios.isAxiosError(error)) {
        const status = error.response?.status;
        if (status === 401) {
            throw new Error('IPFS Authentication failed. Please check your VITE_IPFS_JWT key.');
        }
    }
    throw new Error('Failed to upload file to IPFS. Please check the console for details.');
  }
};
